module.exports = __webpack_public_path__ + "img/Notisphere_Logo_Color_Light.7a0c1cb1.svg";